import { selectSelectedEmployee } from '@store/EmployeeReducer'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { useAppSelector } from '@utils/hooks'
import {
  emailRule,
  requiredRule,
  selectedIdIsNotHimself,
  stringRule,
} from '@utils/rules'
import { Col, DatePicker, Form, Input, Row } from 'antd'
import dayjs from 'dayjs'
import { useEffect } from 'react'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const dateFormat = 'DD/MM/YYYY'
  const item = useAppSelector(selectSelectedEmployee())

  useEffect(() => {
    form.setFieldsValue({
      ...item,
      hireDate: item?.hireDate ? dayjs(item.hireDate) : undefined,
      seniorityDate: item?.seniorityDate
        ? dayjs(item.seniorityDate)
        : undefined,
    })
  }, [item])

  if (!item) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item
        name="id"
        required
        rules={[requiredRule()]}
        style={{ display: 'none' }}
      >
        <Input type="hidden" />
      </Form.Item>
      <Form.Item
        name="matricule"
        label={'Matricule'}
        rules={[requiredRule(), stringRule()]}
      >
        <Input />
      </Form.Item>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item
            name="lastName"
            label={'Nom'}
            rules={[requiredRule(), stringRule()]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="firstName"
            label={'Prénom'}
            rules={[requiredRule(), stringRule()]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        name="email"
        label={'Email'}
        rules={[requiredRule(), emailRule()]}
      >
        <Input />
      </Form.Item>
      <Form.Item name="hireDate" label={"Date d'embauche"} rules={[]}>
        <DatePicker style={{ width: '100%' }} format={dateFormat} />
      </Form.Item>
      <Form.Item name="seniorityDate" label={"Date d'antériorité"} rules={[]}>
        <DatePicker style={{ width: '100%' }} format={dateFormat} />
      </Form.Item>
      <Form.Item
        name="manager"
        label={'Manager'}
        rules={[selectedIdIsNotHimself(item)]}
      >
        <SBAsyncSelect allowClear entity={Entity.employee} size="middle" />
      </Form.Item>
      <Form.Item name="company" rules={[requiredRule()]} label={'Société'}>
        <SBAsyncSelect entity={Entity.company} size="middle" />
      </Form.Item>
      <Form.Item name="job" rules={[requiredRule()]} label={'Poste'}>
        <SBAsyncSelect entity={Entity.job} size="middle" />
      </Form.Item>
    </Form>
  )
}

export default Update
